"use strict";
export var SwapEventName = /* @__PURE__ */ ((SwapEventName2) => {
  SwapEventName2["SWAP_AUTOROUTER_VISUALIZATION_EXPANDED"] = "Swap Autorouter Visualization Expanded";
  SwapEventName2["SWAP_DETAILS_EXPANDED"] = "Swap Details Expanded";
  SwapEventName2["SWAP_ERROR"] = "Swap Error";
  SwapEventName2["SWAP_ESTIMATE_GAS_CALL_FAILED"] = "Swap Estimate Gas Call Failed";
  SwapEventName2["SWAP_FIRST_ACTION"] = "Swap First Action";
  SwapEventName2["SWAP_FIRST_SIGNATURE_REQUESTED"] = "Swap First Signature Requested";
  SwapEventName2["SWAP_MAX_TOKEN_AMOUNT_SELECTED"] = "Swap Max Token Amount Selected";
  SwapEventName2["SWAP_MODIFIED_IN_WALLET"] = "Swap Modified in Wallet";
  SwapEventName2["SWAP_PRESELECT_ASSET_SELECTED"] = "Swap Preselect Asset Selected";
  SwapEventName2["SWAP_PRESET_TOKEN_AMOUNT_SELECTED"] = "Swap Preset Token Amount Selected";
  SwapEventName2["SWAP_PRICE_IMPACT_ACKNOWLEDGED"] = "Swap Price Impact Acknowledged";
  SwapEventName2["SWAP_PRICE_UPDATE_ACKNOWLEDGED"] = "Swap Price Update Acknowledged";
  SwapEventName2["SWAP_QUOTE_FETCH"] = "Swap Quote Fetch";
  SwapEventName2["SWAP_QUOTE_RECEIVED"] = "Swap Quote Received";
  SwapEventName2["SWAP_SIGNED"] = "Swap Signed";
  SwapEventName2["SWAP_SUBMITTED_BUTTON_CLICKED"] = "Swap Submit Button Clicked";
  SwapEventName2["SWAP_TOKENS_REVERSED"] = "Swap Tokens Reversed";
  SwapEventName2["SWAP_TRANSACTION_COMPLETED"] = "Swap Transaction Completed";
  SwapEventName2["SWAP_TRANSACTION_FAILED"] = "Swap Transaction Failed";
  return SwapEventName2;
})(SwapEventName || {});
